import React from 'react';
import {Outlet} from 'react-router-dom';
import DialogRoutes from 'features/layout/DialogRoutes';
import {useSetHistoryPush} from 'redux/history';

export const RootLayout = () => {
   useSetHistoryPush();

   return (
      <>
         <DialogRoutes />
         <Outlet />
      </>
   );
};
